import { Component, HostBinding } from '@angular/core';
import { AuthService, ScreenService, AppInfoService } from './shared/services';
import { TypeHelper } from './core/utils/type-helper.util';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  @HostBinding('class') get getClass() {
    return Object.keys(this.screen.sizes).filter(cl => this.screen.sizes[cl]).join(' ');
  }

  constructor(private authService: AuthService, private screen: ScreenService, public appInfo: AppInfoService) {
    console.log('AppComponent');
  }

  isAuthenticated() {
    let identity = this.authService.getIdentity();
    return this.authService.loggedIn && !TypeHelper.isNullOrEmpty(identity.publicId);
  }
}
